import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-log-viewer',
  templateUrl: './log-viewer.component.html',
  styleUrls: ['./log-viewer.component.css']
})
export class LogViewerComponent implements OnInit {
  logs: string = '';
  loading: boolean = false;
  url;

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.fetchLogs('dashboard');
  }

  // Fetch logs from logFile.php
  fetchLogs(logsId): void {
    logsId == 'webapp'? this.url = 'https://app.voyjaleas.com/myapp/logs/logFile.php' : this.url = 'https://dashboard.voyjaleas.com/api-dashboard/logs/logs/logFile.php';
    this.loading = true;
    this.http.get(this.url, { responseType: 'text' }).subscribe(
      (data) => {
        this.logs = data;
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching logs:', error);
        this.logs = 'Error loading logs.';
        this.loading = false;
      }
    );
  }

  // Clear logs by calling clearLog.php
  clearLogs(logsId): void {
    logsId == 'webapp'? this.url = 'https://app.voyjaleas.com/myapp/logs/clearLog.php' : this.url = 'https://dashboard.voyjaleas.com/api-dashboard/logs/logs/clearLog.php';
    this.http.post(this.url, {}).subscribe(
      () => {
        this.logs = 'Logs cleared.';
      },
      (error) => {
        console.error('Error clearing logs:', error);
      }
    );
  }

  onTabChange(index: number): void {
    if (index === 0) {
      this.loading = true;
      this.fetchLogs('dashboard')
      // You can trigger a function, API call, or update UI state here
    }
    if (index === 1) {
      this.loading = true;
      this.fetchLogs('webapp')
      // You can trigger a function, API call, or update UI state here
    }
  }
}
